export default __webpack_public_path__ + "_/images/app/telegram/telegram-ru-3-7007649a0bd4a7c5d3c18424ae9fe60bd65b74b429bb8489ffdc49f095e0382c.jpg";